import styled from "styled-components";
import { dispositivo } from "../../components/Dispositivos";

export const MyCheck = styled.input`
background:blue;
:checked {
    border: 1px solid blue;
    background:blue;
  }
`;